import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField, Grid, Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { createThirdPartyAction, updateThirdPartyAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import { getClassificationList } from "@icarius-pages/thirdParty/selectors";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";
import CustomNumberFormat from "@icarius-common/dynamicInputs/customNumberFormat";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {
    const { data, handleClose } = props;
    const dispatch = useDispatch();
    const isChile = useIsSocietyCountry("CL");

    const classificationList = useSelector(getClassificationList);

    const create = (dataToSend) => {
        dispatch(createThirdPartyAction(dataToSend)).then((res) => res?.status === 200 && handleClose());
    };

    const modify = (dataToSend) => {
        dispatch(updateThirdPartyAction(dataToSend)).then((res) => res?.status === 200 && handleClose());
    };

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    };

    const { isCreate, formData, setFormValue, submit } = useHandleForm(data, create, modify, openValidationError);

    return (
        <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
            <Grid container item xs={12}>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <TextField
                        disabled={!Boolean(isCreate)}
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("centerCode")}
                        onChange={(e) => setFormValue(e.target.value, "code")}
                        value={formData.code}
                        inputProps={{ maxLength: 20 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("name")}
                        value={formData.name}
                        onChange={(e) => setFormValue(e.target.value, "name")}
                        inputProps={{ maxLength: 60 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-classification`}>
                            {getLocalizedString("thirdPartyClassificationAlt")}
                        </InputLabel>
                        <Select
                            value={formData.classification}
                            labelId={`label-classification`}
                            id={`select-classification`}
                            onChange={(e) => setFormValue(e.target.value, "classification")}
                            margin={"none"}
                        >
                            {classificationList?.map((item) => (
                                <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <TextField
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("address")}
                        value={formData.address}
                        onChange={(e) => setFormValue(e.target.value, "address")}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                {isChile && (
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <TextField
                            fullWidth
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            margin={"none"}
                            label={getLocalizedString("previredCode")}
                            value={formData.previredCode}
                            onChange={(e) => setFormValue(e.target.value, "previredCode")}
                            inputProps={{ maxLength: 3, min: 0, decimals: 0 }}
                        />
                    </Grid>
                )}
                {isChile && (
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <TextField
                            fullWidth
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            margin={"none"}
                            label={getLocalizedString("lreCode")}
                            value={formData.lreCode}
                            onChange={(e) => setFormValue(e.target.value, "lreCode")}
                            inputProps={{ maxLength: 3, min: 0, decimals: 0 }}
                        />
                    </Grid>
                )}
            </Grid>
            <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>
                <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
            </Grid>
        </Grid>
    );
};

export default Form;
